module.exports = __webpack_public_path__ + "img/731703628b2248089a88eb140cc3c7a5.png";